import { ShieldCheck, Leaf, MapPin, FileCheck } from "lucide-react";
import { Reveal, MaskLines } from "./Motion";

const BADGES = [
  { id: "decennale", icon: ShieldCheck, ring: "ASSURANCE • GARANTIE DÉCENNALE •", title: "Garantie Décennale", text: "Tous nos travaux sont couverts 10 ans par notre assurance responsabilité civile décennale." },
  { id: "ecolabel", icon: Leaf, ring: "PEINTURES • ÉCO-RESPONSABLES • ÉCOLABEL •", title: "Peintures Écolabel", text: "Des peintures à faible taux de COV, sans odeur, pour la santé de votre famille et de la planète." },
  { id: "local", icon: MapPin, ring: "ARTISAN LOCAL • ANGERS • ANJOU •", title: "Artisan local", text: "Une entreprise angevine : un interlocuteur proche, réactif et disponible pendant tout le chantier." },
  { id: "devis", icon: FileCheck, ring: "DEVIS GRATUIT • SANS ENGAGEMENT •", title: "Devis gratuit 48h", text: "Visite technique offerte et devis détaillé, poste par poste, sans surprise ni frais cachés." },
];

const Emblem = ({ b }) => (
  <div className="relative h-28 w-28">
    <svg viewBox="0 0 120 120" className="absolute inset-0 h-full w-full transition-transform duration-[1.6s] ease-out group-hover:rotate-[120deg]">
      <defs><path id={`r-${b.id}`} d="M60,60 m-46,0 a46,46 0 1,1 92,0 a46,46 0 1,1 -92,0" /></defs>
      <circle cx="60" cy="60" r="58" fill="none" stroke="#DDD3C4" />
      <text className="fill-ink font-mono" style={{ fontSize: 8.6, letterSpacing: 2.6 }}>
        <textPath href={`#r-${b.id}`}>{b.ring}</textPath>
      </text>
    </svg>
    <div className="absolute inset-[27%] flex items-center justify-center rounded-full bg-ink text-gold transition-colors duration-500 group-hover:bg-gold group-hover:text-ink">
      <b.icon className="h-6 w-6" strokeWidth={1.5} />
    </div>
  </div>
);

export const TrustBadges = () => (
  <section data-testid="trust-badges-section" className="bg-paper px-5 py-24 sm:px-8 lg:py-32">
    <div className="mx-auto max-w-[1400px]">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <p className="eyebrow text-gold-deep lg:col-span-3">Nos engagements</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] lg:col-span-9">
          <MaskLines lines={["Une confiance technique,", <em key="e" className="text-clay">garantie par écrit.</em>]} />
        </h2>
      </div>
      <div className="mt-16 grid grid-cols-1 border-t border-paper-line sm:grid-cols-2 lg:grid-cols-4">
        {BADGES.map((b, i) => (
          <Reveal key={b.id} delay={i * 0.08} testId={`trust-badge-${b.id}`} className="group border-b border-paper-line py-10 sm:px-8 sm:[&:nth-child(odd)]:border-r lg:border-r lg:[&:last-child]:border-r-0 lg:first:pl-0">
            <Emblem b={b} />
            <h3 className="mt-8 font-display text-2xl">{b.title}</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{b.text}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
